import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.split.js';

class GetFirstName {
  execute(name) {
    const firstName = name.split(' ')[0];
    if (!firstName) return null;
    return firstName;
  }
}

export { GetFirstName };
